import React from 'react';
import CustomTable from '../../../../../components/table/CustomTable';
import CustomModal from '../../../../../components/Modal/CustomModal';
import AssignFreeCardTable from '../Table/AssignFreeCardTable';
import AssignFreeCardApp from '../Functionality/AssignFreeCardApp';

const AssignFreeCard = ({ cardsAssign, setCardsAssign, onHide, componentAction, userData, show }) => {

    const {
        getFreeCards,
        selectCardToAssign,
        setSelectCardToAssign,
        isAllChecked,
        setIsAllChecked,
        handleAssign,
        closeModal
    } = AssignFreeCardApp({
                cardsAssign, setCardsAssign, show, componentAction, onHide, userData
            })

    const { tableId, thead, tbody, handleCheckboxChange, handleDeleteAll } = AssignFreeCardTable({
        data: getFreeCards,
        selectedList:selectCardToAssign,
        setSelectedList: setSelectCardToAssign,
        excludedId: cardsAssign,
        setIsAllChecked
    });

    return (
        <CustomModal
            title={'assign_cards'}
            size='xl'
            buttonConfirm='confirm'
            show={show}
            onHide={() => {
                closeModal();
            }}
            onConfirm={() => {
                handleAssign();
            }}
        >
            <CustomTable
                tableId={tableId}
                checkbox={true}
                checkboxTitle={"de_/_select_all"}
                isAllChecked={isAllChecked}
                onChangeCheckbox={handleDeleteAll}
                handleCheckboxChange={handleCheckboxChange}
                selectedList={selectCardToAssign}
                thead={thead}
                tbody={tbody}
                columnActions={false}
                inModal={true}
            />

        </CustomModal>
    );
};

export default AssignFreeCard;
